import { render, staticRenderFns } from "./PriceCard03.vue?vue&type=template&id=79fa5b6a&scoped=true&"
import script from "./PriceCard03.vue?vue&type=script&lang=js&"
export * from "./PriceCard03.vue?vue&type=script&lang=js&"
import style0 from "./PriceCard03.vue?vue&type=style&index=0&id=79fa5b6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa5b6a",
  null
  
)

export default component.exports